import { faHeart } from "@fortawesome/free-regular-svg-icons";
import { faExclamationTriangle, faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { getGradeColor } from "../utils/gradeColors";

const NameTile = ({ name, projectId, onBookmark, maxChars = 0, size = "normal", showDefinition = false, noLink = false }) => {
  const isOverMaxChars = maxChars > 0 && name.name.length > maxChars;

  // Size variants
  const sizeClasses = {
    small: "p-3 min-h-[80px]",
    normal: "p-4 min-h-[110px]",
    large: "p-6 min-h-[160px]",
    hero: "p-8 min-h-[200px]",
  };

  const nameSizeClasses = {
    small: "text-base",
    normal: "text-xl",
    large: "text-2xl",
    hero: "text-4xl",
  };

  const badgeSizeClasses = {
    small: "w-5 h-5 text-[10px]",
    normal: "w-6 h-6 text-xs",
    large: "w-10 h-10 text-base",
    hero: "w-12 h-12 text-xl",
  };

  const content = (
    <div className={`bg-base-100 rounded-lg border-2 border-base-content/10 hover:border-primary/50 transition-colors h-full flex flex-col relative ${sizeClasses[size]} ${isOverMaxChars ? "border-warning/50" : ""}`}>
      {/* Grade badge top-right */}
      {name.trademark && (
        <div className={`absolute top-3 right-3 rounded-full flex items-center justify-center font-bold ${badgeSizeClasses[size]} ${getGradeColor(name.trademark)}`}>
          {name.trademark}
        </div>
      )}
      {/* Sensitivity top-right (offset if grade exists) */}
      {name.sensitivity && (
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className={`absolute top-3 text-warning text-sm ${name.trademark ? "right-16" : "right-3"}`}
        />
      )}
      {/* Heart top-left */}
      {onBookmark && (
        <button
          onClick={e => { e.preventDefault(); e.stopPropagation(); onBookmark(name); }}
          className={`absolute top-3 left-3 text-base-content/20 hover:text-primary transition-colors ${size === "hero" ? "text-xl" : "text-sm"}`}
        >
          <FontAwesomeIcon
            icon={name.bookmarked ? faHeartSolid : faHeart}
            className={name.bookmarked ? "text-primary" : ""}
          />
        </button>
      )}
      {/* Name + Definition centered */}
      <div className="flex-1 flex flex-col items-center justify-center">
        <span className={`font-[Oswald] font-semibold uppercase tracking-tight leading-tight -skew-x-6 text-[#555] text-center px-4 ${nameSizeClasses[size]}`}>
          {name.name}
        </span>
        {showDefinition && name.definition && (
          <p className={`text-base-content/50 italic text-center mt-2 px-4 ${size === "hero" ? "text-sm" : "text-xs"}`}>
            "{name.definition}"
          </p>
        )}
      </div>
    </div>
  );

  if (noLink) {
    return content;
  }

  return (
    <Link to={`/projects/${projectId}/names/${name.id}`} className="block">
      {content}
    </Link>
  );
};

export default NameTile;
export { getGradeColor } from "../utils/gradeColors";
